"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledButtonIcon = exports.StyledEyeIcon = exports.StyledMaskInput = exports.StyledCountryNumber = exports.StyledMaskInputWrapper = exports.StyledHintIcon = exports.StyledHintMessage = exports.StyledResetIcon = exports.StyledInput = exports.InputCommonStyles = exports.StyledInputLabel = exports.StyledGroup = exports.shrinkLabelStyles = void 0;
const theme_1 = require("@pulse-web-ui/theme");
const react_text_mask_1 = __importDefault(require("react-text-mask"));
require("./input.constants");
const responsiveTypography = (0, theme_1.css) `
  ${({ sizeType }) => sizeType === 'm' ? theme_1.typography.regular16 : theme_1.typography.regular18}
`;
const verticalPositionMixin = (0, theme_1.css) `
  top: ${({ sizeType }) => (sizeType === 'm' ? '9px' : '17px')};
`;
const isLargeSize = (sizeType) => sizeType === 'l';
exports.shrinkLabelStyles = (0, theme_1.css) `
  top: 7px;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.text.secondary};
  color: ${({ isError, theme }) => isError && theme.colors.text.error};
  padding-right: ${({ showResetIcon }) => (!showResetIcon ? '16px' : '48px')};
`;
exports.StyledGroup = theme_1.styled.div `
  position: relative;
  width: ${({ width }) => width && `${width}px`};
`;
exports.StyledInputLabel = theme_1.styled.label `
  ${responsiveTypography}
  color: ${({ theme }) => theme.colors.text.secondary};
  word-break: break-word;
  position: absolute;
  pointer-events: none;
  padding-right: 16px;
  left: 16px;
  top: ${({ sizeType }) => (sizeType === 'm' ? '10px' : '19px')};
  transition: 300ms ease all;
  user-select: none;
  width: calc(100% - 16px);
  ${theme_1.mixins.textOverflow()}
  ${({ value, shrink, type }) => {
    return ((Boolean(value === null || value === void 0 ? void 0 : value.length) || shrink || type === 'tel') && exports.shrinkLabelStyles);
}};
  color: ${({ disabled, theme }) => {
    var _a;
    const disabledColor = ((_a = theme.common) === null || _a === void 0 ? void 0 : _a.outlined)
        ? theme.colors.text.tertiary
        : theme.colors.text.secondary;
    return disabled && disabledColor;
}};
  color: ${({ isError, theme }) => isError && theme.colors.text.error};
`;
exports.InputCommonStyles = (0, theme_1.css) `
  ${responsiveTypography}
  -webkit-appearance: none !important;
  box-sizing: border-box;
  width: 100%;
  height: ${({ sizeType }) => (sizeType === 'm' ? '40px' : '56px')};
  border: 2px solid ${(props) => props.theme.colors.neutral[10]};
  border-radius: ${(props) => { var _a; return (_a = props.theme.common.radiusS) !== null && _a !== void 0 ? _a : props.theme.common.radius12; }};
  display: block;
  color: ${(props) => props.theme.colors.text.primary};
  outline: none;
  background: ${(props) => {
    var _a;
    return ((_a = props.theme.common) === null || _a === void 0 ? void 0 : _a.outlined)
        ? 'transparent'
        : props.theme.colors.neutral[10];
}};
  transition: 300ms ease all;

  &:hover {
    background: ${(props) => { var _a; return !((_a = props.theme.common) === null || _a === void 0 ? void 0 : _a.outlined) && props.theme.colors.neutral[20]; }};
    border: 2px solid ${(props) => props.theme.colors.neutral[20]};
  }

  &:disabled {
    background: ${(props) => {
    var _a;
    return ((_a = props.theme.common) === null || _a === void 0 ? void 0 : _a.outlined)
        ? 'transparent'
        : props.theme.colors.neutral[30];
}};
    opacity: 1;
  }

  &:disabled::placeholder,
  &:hover::placeholder {
    opacity: 0;
  }

  &:focus,
  &:focus-within {
    background-color: ${(props) => props.theme.colors.neutral[0]};
    border: 2px solid ${(props) => props.theme.colors.neutral[50]};
    caret-color: ${(props) => props.theme.colors.text.primary};
  }

  &:focus {
    &:hover::placeholder {
      opacity: 1;
    }
  }

  &::placeholder {
    user-select: none;
    color: ${(props) => props.theme.colors.text.secondary};
    -webkit-text-fill-color: ${(props) => props.theme.colors.text.secondary};
  }

  &:disabled {
    user-select: none;
    color: ${(props) => {
    var _a;
    return ((_a = props.theme.common) === null || _a === void 0 ? void 0 : _a.outlined)
        ? props.theme.colors.text.tertiary
        : props.theme.colors.text.secondary;
}};
    border-color: ${(props) => {
    var _a;
    return ((_a = props.theme.common) === null || _a === void 0 ? void 0 : _a.outlined)
        ? props.theme.colors.neutral[10]
        : props.theme.colors.neutral[30];
}};
    -webkit-text-fill-color: ${(props) => props.theme.colors.text.secondary};
  }

  &:hover::placeholder {
    -webkit-text-fill-color: ${(props) => props.theme.colors.text.tertiary};
  }

  &:focus ~ ${exports.StyledInputLabel} {
    ${exports.shrinkLabelStyles};
  }

  &:focus::placeholder {
    -webkit-text-fill-color: ${(props) => props.theme.colors.text.tertiary} !important;
  }

  &:focus ~ span {
    display: block;
  }

  ${({ isError }) => isError &&
    (0, theme_1.css) `
      border: 2px solid ${(props) => props.theme.colors.accent.error.normal};
      border-color: ${(props) => props.theme.colors.accent.error.normal};
      background-color: ${(props) => props.theme.colors.accent.error.faded};

      &:hover,
      &:focus,
      &:disabled {
        border-color: ${(props) => props.theme.colors.accent.error.normal};
        border: 2px solid ${(props) => props.theme.colors.accent.error.normal};
        background-color: ${(props) => props.theme.colors.accent.error.faded};
        color: ${(props) => props.theme.colors.text.primary};
      }

      &::placeholder,
      &:hover::placeholder {
        -webkit-text-fill-color: ${(props) => props.theme.colors.text.error};
      }

      &:focus::placeholder {
        -webkit-text-fill-color: ${(props) => props.theme.colors.text.error} !important;
      }

      &:disabled {
        -webkit-text-fill-color: ${(props) => props.theme.colors.text.error};
      }
    `}

  ${({ warning, isError }) => warning &&
    !isError &&
    (0, theme_1.css) `
      background-color: ${(props) => props.theme.colors.accent.warning.faded};
      border: 2px solid ${(props) => props.theme.colors.accent.warning.normal};
      border-color: ${(props) => props.theme.colors.accent.warning.normal};

      &:hover,
      &:focus {
        border-color: ${(props) => props.theme.colors.accent.warning.normal};
        border: 2px solid ${(props) => props.theme.colors.accent.warning.normal};
        background-color: ${(props) => props.theme.colors.accent.warning.faded};
        color: ${(props) => props.theme.colors.text.primary};
      }

      &::placeholder,
      &:hover::placeholder {
        -webkit-text-fill-color: ${(props) => props.theme.colors.accent.warning.faded};
      }

      &:focus::placeholder {
        -webkit-text-fill-color: ${(props) => props.theme.colors.accent.warning.faded} !important;
      }
    `}
`;
exports.StyledInput = theme_1.styled.input `
  ${exports.InputCommonStyles};
  padding-left: 14px;
  padding-right: ${({ showResetIcon, hintObject }) => (hintObject === null || hintObject === void 0 ? void 0 : hintObject.showIcon) || showResetIcon ? '48px' : '16px'};
  ${({ sizeType, label }) => isLargeSize(sizeType) &&
    (0, theme_1.css) `
      padding-top: 17px;
      padding-bottom: ${label ? '0px' : '16px'};
    `}

  ${({ type }) => type === 'button' &&
    (0, theme_1.css) `
      text-align: left;
    `}

  &::placeholder {
    opacity: 0;
  }

  &:focus::placeholder {
    opacity: 1;
  }
`;
exports.StyledResetIcon = theme_1.styled.span `
  position: absolute;
  ${verticalPositionMixin};
  cursor: pointer;
  right: ${({ hintObject }) => ((hintObject === null || hintObject === void 0 ? void 0 : hintObject.showIcon) ? '45px' : '19px')};
  display: none;
`;
exports.StyledHintMessage = theme_1.styled.div `
  ${theme_1.typography.regular14};
  margin-top: ${({ noMargin }) => (noMargin ? 0 : '8px')};
  color: ${({ theme }) => theme.colors.text.secondary};
  color: ${({ isError, theme }) => isError && theme.colors.text.error};
  color: ${({ warning, theme, isError }) => warning && !isError && theme.colors.text.primary};
  word-break: break-word;
`;
exports.StyledHintIcon = theme_1.styled.span `
  position: absolute;
  right: 19px;
  ${verticalPositionMixin}

  ${({ isError }) => isError &&
    (0, theme_1.css) `
      path {
        fill: ${({ theme }) => isError && theme.colors.icon.error};
      }
    `}
`;
exports.StyledMaskInputWrapper = theme_1.styled.label `
  width: ${({ width }) => (width ? `${width}px` : '100%')};
  height: 56px;
  display: block;
  position: relative;
`;
exports.StyledCountryNumber = theme_1.styled.span `
  ${responsiveTypography}
  line-height: 13px;
  position: absolute;
  left: 16px;
  top: ${({ sizeType }) => (sizeType === 'm' ? '14px' : '21px')};
  color: ${({ theme }) => theme.colors.text.primary};
  color: ${({ isError, theme }) => isError && theme.colors.text.error};
  color: ${({ disabled, theme }) => disabled && theme.colors.text.secondary};

  ${({ label, sizeType }) => label &&
    isLargeSize(sizeType) &&
    (0, theme_1.css) `
      top: 30px;
    `}
`;
exports.StyledMaskInput = (0, theme_1.styled)(react_text_mask_1.default) `
  ${exports.InputCommonStyles};
  padding: 16px 24px 16px ${({ type }) => (type === 'tel' ? '40px' : '14px')};
  color: ${({ isError, theme }) => isError && theme.colors.text.error};
  ${({ label, type, sizeType }) => label &&
    isLargeSize(sizeType) &&
    (0, theme_1.css) `
      padding: 27px 24px 10px ${type === 'tel' ? '40px' : '14px'};
    `}

  &:focus,
  &:hover {
    color: ${({ isError, theme }) => isError && theme.colors.text.error};
  }

  ${({ type }) => type !== 'tel' &&
    (0, theme_1.css) `
      &::placeholder {
        opacity: 0;
      }

      &:focus::placeholder {
        opacity: 1;
      }
    `}

  ${({ type }) => {
    if (type === 'tel') {
        return (0, theme_1.css) `
        &:hover::placeholder {
          opacity: 1;
        }
        &:hover::placeholder {
          -webkit-text-fill-color: ${(props) => props.theme.colors.text.secondary};
        }
      `;
    }
}}
`;
exports.StyledEyeIcon = theme_1.styled.div `
  ${theme_1.mixins.flex({ alignItems: 'center' })}
  position: absolute;
  right: 19px;
  top: 18px;
  height: 20px;
  cursor: pointer;
`;
exports.StyledButtonIcon = theme_1.styled.span `
  position: absolute;
  ${verticalPositionMixin}
  right: 16px;
  cursor: pointer;
`;
